const openFlow = {
    titles: ["Please select one","Mr", "Mrs", "Miss", 'Ms', "Mx","Dr", "Prof","Sir","Dame"]
}

export { openFlow }